<template>
  <section class="playlists">
    <div class="playlists__container">
      <h2 class="playlists__header-title">Playlists</h2>
      <div class="playlists__header-subtitle-wrapper">
        <h4 class="playlists__header-subtitle">Assigned to you</h4>
        <div class="playlists__header-filter-wrapper">
          <div
            v-for="filter in filters"
            :key="`f-${filter.name}`"
            @click="filterHandler(filter.name)"
            :id="`filter-${filter.name}`"
            class="playlists__header-checkbox-wrapper"
          >
            <div class="ine-checkbox__input">
              <input
                class="ine-checkbox"
                type="checkbox"
                name="filter-checkbox"
                v-model="filter.checked"
              />
              <span class="ine-checkbox__control--small">
                <CheckboxTick />
              </span>
            </div>
            <span class="playlists__header-checkbox-label">{{
              filter.label
            }}</span>
          </div>
        </div>
      </div>
      <div class="playlists__section-wrapper">
        <ActionLoader
          v-if="!playlists.length"
          :size="1"
          class="playlists__loader"
        />
        <Playlist
          v-for="playlist of filteredPlaylists"
          :key="playlist.id"
          class="playlists__item"
          :playlist="playlist"
        />
        <div
          v-if="noFilterMatches"
          class="section__wrapper playlists__empty-wrapper "
        >
          <h5 class="section__title">
            We couldn't find any playlists that match your current filters.
          </h5>
          <div class="section__subtitle">
            Try adjusting your filters and trying again.
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Playlist from '@/components/playlists/Playlist.vue'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import CheckboxTick from '@/assets/images/certification/checkbox-tick.svg'

export default {
  name: 'Playlists',
  components: {
    Playlist,
    ActionLoader,
    CheckboxTick: { ...CheckboxTick, name: 'CheckboxTick' },
  },
  data() {
    return {
      filters: [
        {
          name: 'in-progress',
          label: 'In progress',
          checked: false,
          filterCondition(progress) {
            return progress > 0 && progress < 1
          },
        },
        {
          name: 'completed',
          label: 'Completed',
          checked: false,
          filterCondition(progress) {
            return progress === 1
          },
        },
      ],
    }
  },
  computed: {
    ...mapState({
      isPageLoading: state => state.app.isPageLoading,
    }),
    ...mapGetters('playlists', ['playlists']),
    filteredPlaylists() {
      const filters = this.filters.filter(f => f.checked)
      if (!filters.length) return this.playlists
      return this.playlists.filter(p =>
        filters.some(f => f.filterCondition(p.user_status.progress))
      )
    },
    noFilterMatches() {
      return this.playlists.length && !this.filteredPlaylists.length
    },
  },
  methods: {
    ...mapActions('playlists', ['getPlaylists']),
    async fetchPlaylist() {
      this.$store.dispatch('app/setIsPageLoading', true)
      try {
        await this.getPlaylists()
        this.$store.dispatch('app/setIsPageLoading', false)
      } catch (e) {
        this.$router.push({
          name: 'login',
        })
      }
    },
    async queryData() {
      this.$store.dispatch('app/setIsPageLoading', true)
      this.$store.dispatch('content/setIsContentLoading', true)
      try {
        await this.fetchPlaylist()
      } catch (error) {
        this.$store.dispatch('app/setIsPageLoading', false)
        this.$store.dispatch('content/setIsContentLoading', false)
        return error
      }
      this.$store.dispatch('app/setIsPageLoading', false)
      this.$store.dispatch('content/setIsContentLoading', false)
    },
    filterHandler(value) {
      const index = this.filters.findIndex(f => f.name === value)
      this.filters[index].checked = !this.filters[index].checked
    },
  },
  async created() {
    this.queryData()
  },
}
</script>

<style lang="scss" scoped>
.playlists {
  display: flex;
  justify-content: center;
  background-image: url('../assets/images/backgrounds/dashboard_bg.jpg');
  background-size: cover;
  color: var(--white);
  min-height: 100vh;
  padding: 70px 20px 20px 20px;

  @include tablet {
    padding: 110px 20px 20px 20px;
  }
  @include desktop {
    padding: 125px 100px 100px 100px;
  }
  &__container {
    flex: 1;
    max-width: 1240px;
  }

  &__header {
    &-title {
      font-family: var(--font-bold);
      font-size: rem(40px);
      line-height: rem(52px);
      margin: 0px;

      @include tablet {
        font-size: rem(32px);
        line-height: rem(38px);
      }
      @include desktop {
        font-size: rem(40px);
        line-height: rem(52px);
      }
    }
    &-subtitle-wrapper {
      display: flex;
      margin-top: 20px;
      flex-direction: column;
      gap: 10px;
      @include mobile {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
      }
      @include desktop {
        margin-top: 20px;
      }
    }
    &-subtitle {
      font-size: rem(18px);
      line-height: rem(24px);
      margin: 0;
      @include desktop {
        font-size: rem(24px);
        line-height: rem(32px);
      }
    }
    &-filter-wrapper {
      display: flex;
      gap: 20px;
      cursor: pointer;
    }
    &-checkbox-wrapper {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    &-checkbox-label {
      font-size: rem(14);
      line-height: rem(20);
    }
  }

  &__section-wrapper {
    display: flex;
    gap: 20px;
    margin-top: 20px;
    flex-wrap: wrap;
  }
  &__loader {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 80px;
  }
  &__empty {
    justify-content: center;
    &-wrapper {
      width: 100%;
      justify-content: center;
      margin-top: 30px;
      h5,
      div {
        text-align: center;
      }
    }
  }
}
</style>
